import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'social-sign-in',
  templateUrl: './social-sign-in.component.html',
  styleUrls: ['./social-sign-in.component.scss']
})
export class SocialSignInComponent implements OnInit {

  @Input() disabled = false;

  @Output() progress = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnInit(): void {
  }

  signInWithGoogle() {
    this.progress.emit(true);
  }

  signInWithFacebook() {
    this.progress.emit(true);
  }

}
